import { render, staticRenderFns } from "./ActivateSubscription2.vue?vue&type=template&id=89dbe032&scoped=true"
import script from "./ActivateSubscription2.vue?vue&type=script&lang=ts"
export * from "./ActivateSubscription2.vue?vue&type=script&lang=ts"
import style0 from "./ActivateSubscription2.vue?vue&type=style&index=0&id=89dbe032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dbe032",
  null
  
)

export default component.exports